'use client';

import { createContext, useContext } from 'react';

/**
 * Lightweight context that provides the tenant ID for analytics tracking.
 * Used by CTA tracking components (TrackedPhoneLink, ExternalLinkBlockView, etc.)
 * so they can fire beacons without prop drilling through every block component.
 *
 * `null` is the explicit "no tenant" sentinel (tracking disabled, preview mode).
 * Tracked components silently skip the beacon when the value is `null`.
 *
 * Using `null` (rather than `undefined`) means a nested `<AnalyticsProvider
 * value={null}>` still masks an outer tracked tenant — preserving subtree
 * opt-out — and avoids React 19's "value prop is required" error on
 * `<Context.Provider value={undefined}>`.
 */
const AnalyticsContext = createContext<string | null>(null);

export const AnalyticsProvider = AnalyticsContext.Provider;

export function useAnalyticsTenantId(): string | null {
  return useContext(AnalyticsContext);
}
